"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const content_1 = require("@prismicio/types-internal/lib/content");
const ExternalLinkRenderer = {
    renderV1(link) {
        return {
            type: "Link.web",
            value: {
                ...(content_1.FilledExternalLinkContent.is(link) && {
                    url: link.url,
                    ...(typeof link.target === "string" && { target: link.target }),
                }),
                ...(link.text && { text: link.text }),
            },
        };
    },
    renderV2(def, link) {
        return {
            link_type: "Web",
            ...(content_1.FilledExternalLinkContent.is(link) && {
                url: link.url,
                ...(typeof link.target === "string" && { target: link.target }),
            }),
            ...(def.allowText && link.text && { text: link.text }),
        };
    },
    renderMocks(def, link) {
        return this.renderV2(def, link);
    },
};
exports.default = ExternalLinkRenderer;
